export enum AlarmPriority {
  Unknown = 'Unknown',
  Lowest = 'Lowest',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Highest = 'Highest',
}
